var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6131 0H2.85785C1.43627 0 0.279724 1.15655 0.279724 2.57812V19.4219C0.279724 20.8435 1.43627 22 2.85785 22H15.1421C16.5637 22 17.7203 20.8435 17.7203 19.4219V6.13834L11.6131 0ZM12.0913 2.91758L14.7936 5.63368H12.9507C12.4768 5.63368 12.0913 5.24816 12.0913 4.7743V2.91758ZM15.1421 20.2812H2.85785C2.38399 20.2812 1.99847 19.8957 1.99847 19.4219V2.57812C1.99847 2.10427 2.38399 1.71875 2.85785 1.71875H10.3726V4.7743C10.3726 6.19588 11.5292 7.35243 12.9507 7.35243H16.0015V19.4219C16.0015 19.8957 15.616 20.2812 15.1421 20.2812ZM12.5522 12.604L11.3369 13.8194L9.81879 12.3013V17.832H8.10004V12.3013L6.58195 13.8194L5.36662 12.604L8.95941 9.01123L12.5522 12.604Z",
    fill: "#1075FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.55298447a557990c76e34ac88fee4297.svg";
export { ForwardRef as ReactComponent };